// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".thumbnail-button[data-v-dd078808]{position:relative}.thumbnail-button .play-icon[data-v-dd078808]{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.video-player[data-v-dd078808]{max-width:100%}.video-player[data-v-dd078808] mux-player{max-height:99vh}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
